module.exports = __webpack_public_path__ + "static/media/MaskedContextgrid.3b811c72.jpg";